import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import StarRatingComponent from 'react-star-rating-component';
import './styles.css';

const RatingStarsWidgetEditable = props => {
  const { value, size, starsCount } = props;
  const [state, setState] = useState({
    tmpValue: 0,
    value: 0,
  });

  useEffect(() => {
    setState({
      value: Number(value) || 0,
      tmpValue: Number(value) || 0,
    });
  }, [value]);

  const onStarClickHandler = value => {
    const { onChangeHandler, onBeforeChangeHandler } = props;
    if (!onBeforeChangeHandler(value)) {
      return;
    }

    let val = value === state.value ? 0 : value;
    setState({
      value: val,
      tmpValue: val,
    });
    onChangeHandler(val);
  };

  const onStarHoverOutHandler = () => {
    setState({
      ...state,
      tmpValue: state.value,
    });
  };

  const onStarHoverHandler = index => {
    setState({ ...state, tmpValue: index });
  };

  const starIcon = (
    <span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 55.867 55.867"
        width={size}
        height={size}
      >
        <path
          d="M55.818 21.578c-.118-.362-.431-.626-.808-.681l-18.09-2.629-8.09-16.392c-.168-.342-.516-.558-.896-.558s-.729.216-.896.558l-8.091 16.393-18.09 2.629c-.377.055-.689.318-.808.681-.117.361-.02.759.253 1.024l13.091 12.76-3.091 18.018c-.064.375.09.754.397.978.309.226.718.255 1.053.076l16.182-8.506 16.18 8.506c.146.077.307.115.466.115.207 0 .413-.064.588-.191.308-.224.462-.603.397-.978l-3.09-18.017 13.091-12.761c.272-.267.37-.664.252-1.025z"
          fill="inherit"
        />
      </svg>
    </span>
  );

  return (
    <div className="rating-stars-widget rating-stars-widget--editable">
      <StarRatingComponent
        name="ratingHeader"
        starCount={starsCount || 5}
        value={state.tmpValue}
        onStarClick={onStarClickHandler}
        renderStarIcon={() => starIcon}
        onStarHoverOut={onStarHoverOutHandler}
        onStarHover={onStarHoverHandler}
        starColor="#ff4400"
        emptyStarColor="#bbbbbb"
        editing={true}
      />
    </div>
  );
};

RatingStarsWidgetEditable.defaultProps = {
  onChangeHandler: val => {},
  onBeforeChangeHandler: () => {
    return true;
  },
};

RatingStarsWidgetEditable.propTypes = {
  size: PropTypes.number.isRequired,
  starsCount: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onChangeHandler: PropTypes.func,
  onBeforeChangeHandler: PropTypes.func,
};

export default RatingStarsWidgetEditable;
